export default "__VITE_ASSET__Qx8DY_tK__"